<template>
  <div class="w-full h-full px-6 box-border overflow-auto">
    <div class="w-full h-full flex flex-col items-center" v-if="list.length === 0" v-loading="tableLoading">
      <p class="mb-6 text-medium text-black opacity-65" style="margin-top: 144px">暂无收信人</p>
      <el-button type="primary" class="text-medium text-white px-4 py-2" @click="addSms">添加收信人</el-button>
    </div>
    <!-- <div>添加样本数据</div> -->
    <div class="sample-component">
      <AddSampleList @smsSendCallBack="smsSendCallBack" @smsSendTableSuccess="smsSendTableSuccess" :sampleDetails="sampleDetails" :currentPage="currentPage" @selectionChangeEmit="selectionChangeEmit" ref="addSampleList"/>
    </div>
  </div>
</template>

<script>
import ClickDelete from '@/components/PopConfirm.vue'
import DataTable from '@/components/base/DataTable'
import { createPopup } from '@/assets/js/factory'
import { getSmsSamples, removeSmsSamples } from '@/api/wenjuan/sample_new'
import { pageMixins } from '@/mixins/publish'
import GlobalConfig from '@/global/config'
import SmsRecipientDrawer from './SmsRecipientDrawer'
import { recipientColumns } from '../config/sms-sending'
import AddSampleList from '@/views/survey/offline/components/drawer/AddSampleList'
import { getSampleAnsForSms } from '@/api/wenjuan/offline'
export default {
  name: 'StepRecipient',
  mixins: [pageMixins],
  components: {
    DataTable,
    SmsRecipientDrawer,
    ClickDelete,
    AddSampleList
  },
  data() {
    return {
      list: [],
      columns: recipientColumns,
      visible: false,
      selection: [],
      tableLoading: false,
      checkAllSource: false,
      delLoading: false,
      currentPage: 'smsSending',
      tableData: [],
      sampleDetails:{
        tableData: [],
        type : 0,
        group : 0,
        groupName : '',
        checkedSeetingFields: [],
        checkBoxData: []
      }
    }
  },
  inject: {
    source: {
      default: () => ({})
    }
  },
  activated() {
    this.getDetails()
  },
  mounted() {
    this.searchList()
  },
  methods: {
    selectionChangeEmit(val){
      this.list = val;
      if(val.length>0){
        this.$emit('callBackSelection', true);
      }
    },
    // 添加收信人
    addSms(){
      this.$refs.addSampleList.addSample();
    },
    // 短信样本删除所有数据后的回调方式
    smsSendCallBack(){
      this.list = [];
      this.source.selectTotal = 0;
    },
    smsSendTableSuccess(tb) {
      const { total } = tb || {}
      this.source.selectTotal = total ?? 0;
    },
    // 获取样本列表数据
    getDetails(){
      getSampleAnsForSms({
        current: 1,
        size: 10,
        surveyId: GlobalConfig.getSurveyId(),
      }).then(res => {
        if(res.data.code === 0){
          if( res.data.data.tableData && res.data.data.tableData.records.length > 0){
            this.sampleDetails = {
              type: res.data.data.type,
              group: res.data.data.group,
              groupName: res.data.data.groupName,
              tableData: res.data.data.tableData.records,
              checkedSeetingFields: [],
              checkBoxData: [],
              page: {
                total: res.data.data.tableData.total,
                size: res.data.data.tableData.size,
                current: res.data.data.tableData.current,
              }
            }
            this.list = res.data.data.tableData.records;
            this.source.selectTotal = res.data.data.tableData.total;
          }
        }
      })
    }
  },
  created(){
    this.getDetails();
  }
}
</script>
<style lang="scss" scoped>
.sample-component{
  margin-top: 16px;
}
</style>
